import { Button, LinkButton } from "@/ui/Button";
import { MicIcon } from "@/ui/MicIcon";
import { Orb } from "@/ui/Orb";
import { Screen } from "@/ui/Screen";
import { Display, Tiny } from "@/ui/Text";

interface TalkInvitationProps {
  readonly onTry: () => void;
  readonly onLater: () => void;
}

/** The last screen of first run: one obvious thing to do, which is to start talking. */
export function TalkInvitation({ onTry, onLater }: TalkInvitationProps) {
  return (
    <Screen centred middle>
      <Orb size={116} floating />
      <Display className="mt-7">Now ask her anything.</Display>
      <Tiny className="mt-3 max-w-[300px]">
        Talk out loud, in English or Hindi. You can cut in or change your mind halfway, and she’ll
        follow.
      </Tiny>
      <div className="mt-8 flex w-full flex-col items-center gap-3">
        <Button label="Tap to speak to Antar" icon={<MicIcon />} onClick={onTry} />
        <Tiny>Your first three minutes are free.</Tiny>
        <LinkButton label="Maybe later" onClick={onLater} />
      </div>
    </Screen>
  );
}
